import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollContainer", "content"]
  static values = {
    speed: { type: Number, default: 1 },
  }

  connect() {
    this.scrollPosition = 0
    this.isHovering = false
    this.contentWidth = this.contentTarget.offsetWidth
    this.cloneContent()
    this.animate()
  }

  cloneContent() {
    const clone = this.contentTarget.cloneNode(true)
    this.scrollContainerTarget.appendChild(clone)

    // Update content width after cloning
    this.contentWidth = this.scrollContainerTarget.scrollWidth / 2
  }

  animate() {
    if (!this.isHovering) {
      this.scrollPosition += this.speedValue
      if (this.scrollPosition >= this.contentWidth) {
        this.scrollPosition = 0
      }
      this.scrollContainerTarget.scrollLeft = this.scrollPosition
    }
    requestAnimationFrame(this.animate.bind(this))
  }

  mouseEnter() {
    this.isHovering = true
  }

  mouseLeave() {
    this.isHovering = false
  }
}
